export default __webpack_public_path__ + "static/media/about.6d4700a1.svg";